import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { withNamespaces } from "react-i18next";
import posed from "react-pose";
import { Product } from "../Products";

const PoseOverlay = posed.div({
  open: {
    delayChildren: 300,
    staggerChildren: 150
  },
  closed: { delay: 300 }
});

const PoseItem = posed.div({
  open: { x: 0, opacity: 1 },
  closed: { x: 100, opacity: 0 }
});

const ProductType = PropTypes.shape({
  sku: PropTypes.string,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  image: PropTypes.string,
  url: PropTypes.url,
  video: PropTypes.video,
  wishlisted: PropTypes.bool
});

const renderLayer = (
  layerName,
  product,
  onToggleWishlist,
  onOpenVideo,
  onBuyProduct
) => {
  return (
    <PoseItem className="layer-wrap">
      <span className="title">{layerName.toUpperCase()}</span>
      <Product
        product={product}
        onToggleWishlist={onToggleWishlist}
        onOpenVideo={onOpenVideo}
        onBuyProduct={onBuyProduct}
      />
    </PoseItem>
  );
};

class ResultLayers extends PureComponent {
  static propTypes = {
    layer1: ProductType,
    layer2: ProductType,
    layer3: ProductType,
    protip: PropTypes.string,
    onToggleWishlist: PropTypes.func,
    onOpenVideo: PropTypes.func,
    onBuyProduct: PropTypes.func
  };

  static defaultProps = {
    layer1: null,
    layer2: null,
    layer3: null,
    protip: null,
    onToggleWishlist: () => {},
    onOpenVideo: () => {},
    onBuyProduct: () => {}
  };

  state = {
    isOpen: false
  };

  componentDidMount() {
    this.setState({ isOpen: true });
  }

  renderProtip = () => {
    if (this.props.protip) {
      return (
        <PoseItem className="protip-wrap">
          <div className="protip-header">
            <i className="icon-profitip" />
            <span className="protip-title">
              {this.props.t("results:protip")}
            </span>
          </div>
          <span className="protip-content">{this.props.protip}</span>
        </PoseItem>
      );
    }
    return null;
  };

  render() {
    const props = this.props;

    return (
      <PoseOverlay
        className="content"
        pose={this.state.isOpen ? "open" : "closed"}
      >
        {props.layer1 &&
          renderLayer(
            props.t("results:layers.layer_1"),
            props.layer1,
            props.onToggleWishlist,
            props.onOpenVideo,
            props.onBuyProduct
          )}
        {props.layer2 &&
          renderLayer(
            props.t("results:layers.layer_2"),
            props.layer2,
            props.onToggleWishlist,
            props.onOpenVideo,
            props.onBuyProduct
          )}
        {props.layer3 &&
          renderLayer(
            props.t("results:layers.layer_3"),
            props.layer3,
            props.onToggleWishlist,
            props.onOpenVideo,
            props.onBuyProduct
          )}

        {this.renderProtip()}
      </PoseOverlay>
    );
  }
}

export default withNamespaces(["results", "common"], { wait: true })(
  ResultLayers
);
